module.exports = __webpack_public_path__ + "img/vote-btn_txt3.51b61a1a.png";